import { NameDto } from '@model/NameDto'

export enum IntervalType {
  Daily = 1,
  Monthly = 2,
  Yearly = 3,
}

interface MetricsDto {
  startDate: string
  endDate: string
  intervalType: NameDto
}

export interface MetricsCountDto extends MetricsDto {
  count: number
}

export interface MetricsNVDto extends MetricsDto {
  notionalVolumeUsd: number
}

export interface MetricsLotsDto extends MetricsDto {
  lots: number
}

export interface MetricsDepositsDto extends MetricsDto {
  totalDeposits: number
}

export interface MetricsNetDepositsDto extends MetricsDto {
  totalNetDeposits: number
}

export interface MetricsIBCommissionsDto extends MetricsDto {
  commission: number
}
